import React from 'react';

function statusClass(stageOrStatus) {
    const v = (stageOrStatus || '').toLowerCase();
    if (v === 'final') return 'status-final';
    if (v.includes('draft')) return 'status-draft-1';
    if (v === 'coming soon') return 'status-coming-soon';
    if (v) return 'status-work-in-progress';
    return '';
}

export default function BookGrid({ series, signedIn, onSignIn, onSeriesClick }) {
    if (!series.length) {
        return (
            <div style={{ textAlign: 'center', padding: '48px 0', color: 'var(--ink-3)', fontSize: 13 }}>
                No series available.
            </div>
        );
    }

    return (
        <div className="book-grid">
            {series.map(s => {
                const accentCls = 'accent-' + (s.accent || 'sky');
                const books = s.books || [];
                const stage = s.status || s.stage || '';
                const hasLocked = !signedIn && books.some(b => b.loginRequired || b.gated);

                return (
                    <div
                        key={s.id || s.title}
                        className={`book-card ${accentCls}`}
                        onClick={() => onSeriesClick(s)}
                    >
                        <div className="book-card-top">
                            <span className="book-card-mark">◈</span>
                            <div className="book-card-tags">
                                {stage && (
                                    <span className={'status-pill ' + statusClass(stage)}>{stage}</span>
                                )}
                                {hasLocked && (
                                    <span className="status-pill status-login-required">some locked</span>
                                )}
                                <span className="book-card-count">
                                    {s.count ?? books.length}&nbsp;
                                    {(s.count ?? books.length) === 1 ? 'book' : 'books'}
                                </span>
                            </div>
                        </div>
                        <h3>{s.title}</h3>
                        <div className="book-card-genre">{s.genre}</div>
                        <p>{s.blurb || s.description}</p>
                        <span className="link-arrow">View details →</span>
                    </div>
                );
            })}
        </div>
    );
}
